import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: {
      // Navigation
      'nav.home': 'Home',
      'nav.newComplaint': 'Register Complaint',
      'nav.newComplaint.short': 'Register',
      'nav.trackComplaint': 'Track Complaint',
      'nav.trackComplaint.short': 'Track',
      'nav.login': 'Login',
      'nav.dashboard': 'Dashboard',
      'nav.admin': 'Admin Panel',
      'nav.logout': 'Logout',

      // Home Page
      'home.title': 'Collector Office, Gadchiroli',
      'home.subtitle':
        'Collectors Office, Gadchiroli Citizen Grievance Redressal Center',
      'home.registerCard.title': 'Register New Complaint',
      'home.registerCard.description':
        'Submit a new complaint about civic issues in your area',
      'home.registerCard.button': 'Get Started',
      'home.complaintStatistics': 'Complaint Statistics',
      'home.totalRegistered': 'Total Registered',
      'home.complaintsReceived': 'Complaints Received',
      'home.successfullyResolved': 'Successfully Resolved',
      'home.complaintsClosed': 'Complaints Closed',
      'home.resolutionRate': 'Resolution Rate',
      'home.successPercentage': 'Success Percentage',
      'home.trackCard.title': 'Track Your Complaint',
      'home.trackCard.description':
        'Check the status of your submitted complaints',
      'home.trackCard.button': 'Track Now',
      'home.services.title': 'Citizen Services',
      'home.services.subtitle':
        'Access our complaint management services to report civic issues and track their resolution',
      'home.process.title': 'How It Works',
      'home.process.title1': '1',
      'home.process.title2': '2',
      'home.process.title3': '3',
      'home.process.subtitle':
        'Our streamlined process ensures your complaints are handled efficiently and transparently',
      'home.process.step1.title': 'Submit Complaint',
      'home.process.step1.description':
        'Fill out the complaint form with detailed information and supporting evidence',
      'home.process.step2.title': 'Get Complaint ID',
      'home.process.step2.description':
        "Receive a unique tracking ID to monitor your complaint's progress",
      'home.process.step3.title': 'Track Progress',
      'home.process.step3.description':
        'Monitor real-time updates and receive notifications on resolution status',
      'home.contact.title': 'Need Assistance?',
      'home.contact.subtitle':
        'Contact our support team for help with your complaints or general inquiries',
      'home.contact.phone': 'Phone',
      'home.contact.email': 'Email',
      'home.contact.subtitle':
        'Contact our support team for complaints or other queries',
      'home.contact.phone': 'Phone Support',
      'home.contact.phoneDesc': 'Direct phone assistance',
      'home.contact.email': 'Email Support',
      'home.contact.emailDesc': 'Send us your queries',
      'home.contact.whatsapp': 'WhatsApp Chat',
      'home.contact.whatsappDesc': 'Instant chat support',
      'home.contact.whatsappNote': 'Scan QR or click to chat',
      'home.contact.startChat': 'Start Chat',
      'home.weblink.1': 'Gadchiroli District Website',
      'home.weblink.2': 'Contact List (Officers)',
      'home.weblink.3': 'Aaple Sarkar Portal',
      'home.footer': 'Copyright © 2025.All rights reserved.',
      'header.Shri. Devendra Fadnavis': 'Shri. Devendra Fadnavis',
      'header.cm.note': 'Chief Minister, Maharashtra &',
      'header.cm.note1': 'Guardian Minister, Gadchiroli',
      'header.Shri. Ashish Jaiswal': 'Adv. Shri. Ashish Jaiswal',
      'header.Co-Guardian Minister, Gadchiroli':
        'Minister of State, Maharashtra &',
      'header.note2': 'Co-Guardian Minister, Gadchiroli',
      'header.pulic.request': ' JANANIVEDAN',
      'header.public.note':
        'Your Opinions And Complaints Directly To The Administration',
      'home.trackcard.citizennote': 'Citizen Grievence Redressal Centre',

      // New Complaint Page

      'complaint.new.title': 'Register New Complaint',
      'complaint.new.subtitle':
        'Fill out the form below to submit your complaint',
      'complaint.new.complaintdetail': 'Complaint Details',
      'complaint.form./2000': '/2000',
      'complaint.form.name': 'Full Name',
      'complaint.form.mobile': 'Mobile Number',
      'complaint.form.email': 'Email-Id',
      'complaint.form.dob': 'Date of Birth',
      'complaint.form.age': 'Age',
      'complaint.form.gender': 'Gender',
      'complaint.form.male': 'Male',
      'complaint.form.female': 'Female',
      'complaint.form.prepernottosay': 'Prefer Not To Say',
      'complaint.form.providedetailed':
        'Please provide detailed information about your complaint',
      'complaint.form.personalinformation': 'Personal Information',
      'complaint.form.choosedepartment': 'Choose The Department',
      'complaint.form.note':
        'JPG, PNG, PDF, DOC (max 10MB each, up to 5 files)',
      'complaint.form.address': 'Full Address',
      'complaint.form.submitnote':
        'Disclaimer - By submitting this form, you agree to provide accurate information',
      'complaint.form.submitcomplaint': 'Submit Complaint',
      'complaint.form.village': 'Village',
      'complaint.form.taluka': 'Taluka',
      'complaint.form.Department': 'Department',
      'complaint.form.description': 'Complaint Description',
      'complaint.form.photo': 'Upload Photo',
      'complaint.form.ChooseFiles': 'Choose Files',
      'complaint.form.submit': 'Raise New complaint',
      'complaint.form.submitting': 'Submitting...',
      'complaint.categories.water': 'Water Supply',
      'complaint.categories.road': 'Road & Transport',
      'complaint.categories.electricity': 'Electricity',
      'complaint.categories.sanitation': 'Sanitation',
      'complaint.categories.healthcare': 'Healthcare',
      'complaint.categories.education': 'Education',
      'complaint.categories.other': 'Other',
      'complaint.categories.revenu': 'Revenue Department',
      'complaint.categories.police': 'Police Department',
      'complaint.categories.healtdpt': 'Health Department',
      'complaint.categories.educationDpt': 'Education Department',
      'complaint.categories.food': 'Food & Civil Department',
      'complaint.categories.SocialWelfare': 'Social Welfare Department',
      'complaint.categories.labourDpt': 'Labour Department',
      'complaint.categories.transportDpt': 'Transport Department',
      'complaint.categories.electricityDpt': 'Electricity Board',
      'complaint.success.title': 'Complaint Submitted Successfully!',
      'complaint.success.id': 'Your Complaint ID is:',
      'complaint.success.note':
        'Please save this ID for tracking your complaint status.',
      'complaint.success.close': 'Close',
      'complaint.CopyID': 'Copy ID',
      'complaint.RaiseNewcomplaint': 'Raise New complaint',
      'complaint.Track Complaint': 'Track Complaint',
      'complaint.track': '✅ Copied to clipboard!',
      'complaint.trackcomplaint': '✅ Copied ',
      'otp.title': 'OTP Verification',
      'otp.sentTo': 'Enter the 6-digit OTP sent to',
      'otp.expired': 'OTP Expired',
      'otp.expiresIn': 'OTP expires in',
      'otp.verifying': 'Verifying...',
      'otp.verify': 'Verify OTP',
      'otp.didNotReceive': "Didn't receive OTP?",
      'otp.resend': 'Resend OTP',
      'otp.back': 'Back',
      'otp.success.title': 'Verified',
      'otp.success.message': 'Your OTP has been verified successfully!',
      'otp.mobile': 'Mobile:',

      //How It Works
      'howItWorks.title': 'How It Works',
      'howItWorks.steps.submitComplaint.title': 'Submit Complaint',
      'howItWorks.steps.submitComplaint.description':
        'Fill out the form with your details',
      'howItWorks.steps.getComplaintID.title': 'Get Complaint ID',
      'howItWorks.steps.getComplaintID.description':
        'Receive unique tracking number',
      'howItWorks.steps.officialReview.title': 'Official Review',
      'howItWorks.steps.officialReview.description':
        'Government officer processes complaint',
      'howItWorks.steps.trackProgress.title': 'Track Progress',
      'howItWorks.steps.trackProgress.description':
        'Monitor status anytime online',
      'howItWorks.bottomNote': '✅ No login required for citizens',

      // Track Complaint Page

      'track.title': 'Track Your Complaint',
      'track.titlenote': 'Complaint Tracking System',
      'track.subtitle': 'Enter your complaint ID to check the current status',
      'track.form.searchmethod': 'Choose search method:',
      'track.form.id': 'Complaint ID',
      'track.form.mobilenumber': 'Mobile Number',
      'track.form.enterComplaintId': 'Enter Complaint ID',
      'track.form.placeholder': 'Enter your complaint ID ',
      'track.form.placeholdermobile': 'Enter your mobile number ',
      'track.form.pleaseEnter': 'Please enter a complaint ID',
      'track.form.trackbyid': 'Track by ID',
      'track.form.trackbymobile': 'Track by Mobile Number',
      'track.form.demotesting': 'Demo Data for Testing:',
      'track.form.search': 'Search',
      'track.form.searching': 'Searching...',
      'track.form.trackButton': 'Track Complaint',
      'track.notFound':
        'Complaint not found. Please check your ID and try again.',
      'track.demo.title': 'Demo Complaint IDs for Testing:',
      'track.demo.try': 'Try: CMP001 or CMP002',
      'track.demo.sample': 'Sample complaints for demonstration',
      'track.progress.title': 'Track Your Progress',
      'track.steps.enter.title': 'Enter Complaint ID',
      'track.steps.enter.description': 'Use your unique tracking number',
      'track.steps.view.title': 'View Status',
      'track.steps.view.description': 'Check current progress instantly',
      'track.steps.updates.title': 'Get Updates',
      'track.steps.updates.description': 'Receive real-time notifications',
      'track.steps.resolution.title': 'Track Resolution',
      'track.steps.resolution.description': 'Monitor until completion',
      'track.realtime': '🔍 Real-time complaint tracking!',
      'track.error.mobileInIdField': "Please enter a valid Complaint ID.",
      'track.error.invalidId': "Please enter a valid Complaint ID.",
      'track.details.title': 'Complaint Details',
      'track.details.id': 'Complaint ID',
      'track.details.basicInfo': 'Basic Information',
      'track.details.name': 'Name',
      'track.details.mobile': 'Mobile',
      'track.details.address': 'Address',
      'track.details.village': 'Village',
      'track.details.taluka': 'Taluka',
      'track.details.category': 'Category',
      'track.details.description': 'Description',
      'track.details.status': 'Status',
      'track.details.submitted': 'Submitted',
      'track.details.applicant': 'Applicant Details',
      'track.details.department': 'Department',
      'track.details.departmentLabel': 'Department',
      'track.details.assignedTo': 'Assigned To',
      'track.timeline.title': 'Status Timeline',
      'track.Found': 'Found',
      'track.ComplaintsforMobile': 'Complaints for Mobile:',
      'track.ViewDetails': 'View Details',
      'track.Scrolltoseeall': 'Scroll to see all',
      'track.id': 'ID',
      'TRACK.ID': 'ID:',
      'track.BasicInformation': 'Basic Information',
      'track.Description': ' Description',
      'track.Village': 'Village',
      'track.Taluka': 'Taluka',
      'track.Applicant Details': ' Applicant Details',
      'track.Citizen Attachments': ' Citizen Attachments',
      'track.Nocitizenattachments': '  No citizen attachments',
      'track.note1':
        ' The citizen did not attach any files with this complaint.',
      'track.Officer Attachments': ' Officer Attachments',
      'trackNoofficerattachments': ' No officer attachments',
      'track.note2': 'The officer has not attached any resolution photos yet.',
      'track.Department & Assignment': ' Department ',
      'track.Department': ' Department',
      'track.Assigned To': ' Assigned To',
      'track.Submitted Date': 'Submitted Date',
      'track.Status Timeline': 'Status Timeline',
      'track.Officer Comments & Updates': ' Officer Comments & Updates',
      'track.Public Comment': 'Public Comment',
      'track.No public comments from officers yet':
        ' No public comments from officers yet',
      'track.note3':
        ' Officers will post updates here as they work on your complaint.',
      'track.note4': 'Note:',
      'track.note4info': 'Only public comments from officers are shown here.',
      'track.rating': 'Your Rating',
      'track.ratenow': 'Rate this complaint resolution',
      'track.rate': 'Your rating',
      'track.Addyourfeedback ': ' Add your feedback ',
      'track.Cancel': ' Cancel',
      'track.Writeyourcommenthere...': ' Write your comment here...',
      'track.RateResolution': 'Rate Resolution',
      'track.Reopen Complaint': 'Reopen Complaint',
      'track.Submitting...': 'Submitting...',
      'track.Submit': 'Submit',
      'Excellent': 'Excellent',
      'Good': 'Good',
      'Average': 'Average',
      'Poor': 'Poor',
      'Very Poor': 'Very Poor',
      'track.Copied!': ' Copied!',
      'track.rating.yourRating': 'Your Rating',
      'track.rating.title': 'Rate Resolution Quality',
      'track.rating.selectStar': 'Select a rating',
      'track.rating.commentPlaceholder': 'Add a comment about the resolution (optional)...',
      'track.rating.submit': 'Submit Rating',
      'track.rating.success': 'Thank you for your feedback!',
      'track.rating.error': 'Failed to submit rating. Please try again.',
      'track.rating.pleaseSelect': 'Please select a rating',

      // Login Page
      'login.title': 'Officer Portal Login',
      'login.subtitle': 'Sign in to manage complaints',
      'login.forcitizen': 'For Citizens',
      'login.citizennote':
        'Citizens can directly submit and track complaints without creating accounts.',
      'login.noterequired': 'No login required!',
      'login.GovernmentPortal': "Officer's Portal",
      'login.governmentportalnote': 'Authorized Personnel Only',
      'login.GovernmentStaffAccessOnly': 'Government Staff Access Only',
      'login.accessnote':
        'This portal is restricted to authorized government officers only. All activities are logged and monitored for security purposes.',
      'login.notfillpassword': 'Enter your password',
      'login.notfillemail': 'Enter your official email',
      'login.AreyouaCitizen': 'Are you a citizen?',
      'login.citizennote':
        'Citizens can submit and track complaints directly without accounts.',
      'login.citizenportal': 'Go to Citizen Portal',
      'login.notfillusername': 'Enter your user name',
      'login.email': 'Email Address',
      'login.password': 'Password',
      'login.signin': 'Sign In',
      'login.signing': 'Signing in...',
      'login.error': 'Invalid email or password',
      'login.demo.title': 'Demo Login Credentials:',
      'login.demo.officer': 'Department Officer',
      'login.demo.taluka': 'Taluka Officer',
      'login.demo.collector': 'District Collector',
      'login.demo.admin': 'Admin',
      'login.username': 'User Name',
      'login.forgotPassword': 'Reset Password',
      'login.forgotnote': 'Enter your email or username',
      'login.placeholderresetpassword': 'Email or username',
      'login.cancel': 'Cancel ',
      'login reset': 'Reset ',

      // Dashboard
      'dashboard.title': 'Officer Dashboard',
      'dashboard.welcome': 'Welcome back',
      'dashboard.stats.total': 'Total Complaints',
      'dashboard.stats.pending': 'Pending',
      'dashboard.stats.progress': 'In Progress',
      'dashboard.stats.resolved': 'Resolved',
      'dashboard.search.placeholder': 'Search complaints...',
      'dashboard.search.advanced': 'Advanced Search',
      'dashboard.filter.status': 'Status',
      'dashboard.filter.category': 'Category',
      'dashboard.filter.priority': 'Priority',
      'dashboard.filter.assignedTo': 'Assigned To',
      'dashboard.filter.age': 'Complaint Age',
      'dashboard.filter.village': 'Village',
      'dashboard.filter.clear': 'Clear Filters',
      'dashboard.filter.save': 'Save Search',
      'dashboard.table.id': 'ID',
      'dashboard.table.citizen': 'Citizen',
      'dashboard.table.category': 'Category',
      'dashboard.table.status': 'Status',
      'dashboard.table.priority': 'Priority',
      'dashboard.table.date': 'Date',
      'dashboard.table.actions': 'Actions',
      'dashboard.actions.view': 'View Details',
      'dashboard.actions.assign': 'Assign',
      'dashboard.actions.update': 'Update Status',

      // Status values
      'status.submitted': 'Submitted',
      'status.inProgress': 'In Progress',
      'status.resolved': 'Resolved',
      'status.escalated': 'Escalated',

      // Priority values
      'priority.low': 'Low',
      'priority.medium': 'Medium',
      'priority.high': 'High',
      'priority.critical': 'Critical',

      // Common
      'common.loading': 'Loading...',
      'common.save': 'Save',
      'common.cancel': 'Cancel',
      'common.close': 'Close',
      'common.delete': 'Delete',
      'common.edit': 'Edit',
      'common.add': 'Add',
      'common.search': 'Search',
      'common.filter': 'Filter',
      'common.export': 'Export',
      'common.refresh': 'Refresh',
      'common.language': 'Language',

      // Additional form placeholders and validation
      'form.selectCategory': 'Select Category',
      'form.selectVillage': 'Select Village/Taluka',
      'form.photoUploadNote':
        'Upload a photo related to your complaint (JPG, PNG, max 5MB)',
      'form.submitAnother': 'Submit Another Complaint',

      // Additional workflow items
      'flowMenu.citizenLogin': 'Citizen Login',
      'flowMenu.registeredComplaint': 'Registered Complaint',
      'flowMenu.verifyComplaint': 'Verify Complaint',
      'flowMenu.trackComplaint': 'Track Complaint',

      // Dashboard detail modal
      'dashboard.modal.complaint': 'Complaint',
      'dashboard.modal.actionTimeline': 'Action Timeline',
      'dashboard.modal.commentsUpdates': 'Comments & Updates',
      'dashboard.modal.citizenAttachments': 'Citizen Attachments',
      'dashboard.modal.officerResolutionPhotos': 'Officer Resolution Photos',
      'dashboard.modal.noTimeline': 'No timeline available',
      'dashboard.modal.noComments': 'No comments yet',
      'dashboard.modal.addFirstComment': 'Add the first comment',
      'dashboard.modal.public': 'Public',
      'dashboard.modal.internal': 'Internal',
      'dashboard.modal.view': 'View',
      'dashboard.modal.download': 'Download',
      'dashboard.modal.close': 'Close',
      'dashboard.modal.specialInstructions': 'Special Instructions',
      'dashboard.modal.assignmentInfo': 'Assignment Information',
      'dashboard.modal.assignedTo': 'Assigned To',
      'dashboard.modal.assignmentDate': 'Assignment Date',
      'dashboard.modal.detailsOfIssue': 'Details of the Issue:',
      'dashboard.modal.location': 'Location:',
      'dashboard.modal.reportedDate': 'Reported Date:',
      'dashboard.modal.contact': 'Contact:',
      'dashboard.modal.assignedDepartment': 'Assigned Department:',
      'dashboard.modal.verified': '✓ Verified',
      'dashboard.modal.resolutionEvidence': '✓ Resolution Evidence',
      'dashboard.modal.noPhotos': 'No photos uploaded by citizen',
      'dashboard.modal.noResolutionPhotos':
        'No resolution photos uploaded by officer',
      'dashboard.modal.uploadedByCitizen': 'Uploaded by citizen',
      'dashboard.modal.uploadedByOfficer': 'Uploaded by Officer',
      'dashboard.modal.unknownSize': 'Unknown size',
      'dashboard.modal.by': 'By:',
      'dashboard.modal.dashboard': 'Dashboard',
      'dashboard.modal.gadchiroliDistrict': 'Gadchiroli District',
      'dashboard.welcome.user': 'Welcome,',
      'dashboard.welcome.manageComplaints':
        'Manage and resolve citizen complaints efficiently',
      'dashboard.welcome.overseeComplaints':
        'Oversee complaints from your taluka area',
      'dashboard.welcome.monitorComplaints':
        'Monitor critical and escalated complaints',
      'dashboard.timeline.statusUpdated': 'Status Updated',
      'dashboard.timeline.priorityUpdated': 'Priority Updated',
      'dashboard.timeline.complaintSubmitted': 'Complaint Submitted',
      'dashboard.timeline.complaintAssigned': 'Complaint Assigned',
      'dashboard.timeline.complaintResolved': 'Complaint Resolved',
      'dashboard.timeline.complaintRejected': 'Complaint Rejected',
      'dashboard.timeline.commentAdded': 'Comment Added',
      'dashboard.timeline.documentUploaded': 'Document Uploaded',
      'dashboard.timeline.actionTaken': 'Action Taken',
      'dashboard.timeline.complaintReopened': 'Complaint Reopened',
      'dashboard.timeline.statusUpdatedNote': 'Status updated:',
      'dashboard.timeline.priorityChangePattern': 'Priority changed from {{from}} to {{to}}',
      'dashboard.common.pleaseLogin': 'Please log in to access the dashboard.',
      'dashboard.common.logoutConfirm': 'Do you want to logout?',
      'dashboard.common.user': 'User',
      'dashboard.common.officer': 'Officer',
      'dashboard.common.system': 'System',
      'dashboard.common.citizen': 'Citizen',
      'dashboard.header.district': 'Gadchiroli District',
      'dashboard.header.user': 'User',
      'accessibility.fontSize.increase': 'Increase font size',
      'accessibility.fontSize.normal': 'Normal font size',
      'accessibility.fontSize.decrease': 'Decrease font size',
      'accessibility.fontSize.extraLarge': 'Extra large font size',
      'accessibility.language.switchToEnglish': 'Switch to English',
      'accessibility.language.switchToMarathi': 'Switch to Marathi',
      'dashboard.comments.addComment': 'Add comment',
      'dashboard.comments.addPublicComment': 'Add Public comment...',
      'dashboard.comments.addInternalComment': 'Add Internal comment...',
      'dashboard.comments.send': 'Send',
      'dashboard.comments.attachFile': 'Attach File',
      'dashboard.comments.publicCommentAdded': 'Public Comment Added',
      'dashboard.comments.internalCommentAdded': 'Internal Comment Added',
      'dashboard.comments.post': 'Post',

      // Admin Page - navigation
      'admin.title': 'Administrative Dashboard',
      'admin.pleaseLogin':
        'Please log in to access the administrative dashboard.',
      'admin.nav.dashboard.label': 'Analytics Dashboard',
      'admin.nav.dashboard.description': 'View System Metrics And Performance',
      'admin.nav.reports.label': 'Advanced Reports',
      'admin.nav.reports.description': 'Generate Detailed Analytics Reports',
      'admin.nav.officers.label': 'Manage Users',
      'admin.nav.officers.description': 'Add, Edit, and Manage System Users',

      // Admin Page - Add User Form
      'admin.form.enterFullName': 'Enter Full Name',
      'admin.form.enterEmail': 'Enter Email',
      'admin.form.enterUserName': 'Enter User Name',

      // Admin Page - dashboard cards & sections
      'admin.cards.totalComplaints': 'Total Complaints',
      'admin.cards.resolved': 'Resolved',
      'admin.cards.pending': 'Pending',
      'admin.cards.overdue21Days': 'OverDue(21 Days)',
      'admin.section.complaintsManagement': 'Complaints Management',
      'admin.section.raiseComplaint': 'Raise Complaint',
      'admin.search.placeholder':
        'Search complaints by ID, name...',

      // Admin Page - complaint detail modal
      'admin.modal.complaintDescription': 'Complaint Description',
      'admin.modal.officerNotes': 'Officer Notes',
      'admin.modal.actionTimeline': 'Action Timeline',
      'admin.modal.noTimeline': 'No timeline available',
      'admin.modal.close': 'Close',
      'admin.modal.noDescription':
        'No description available for this complaint.',
      status: {
        allStatus: 'All Status',
        new: 'New',
        NEW: 'New',
        inProgress: 'In Progress',
        In_Progress: 'In Progress',
        IN_PROGRESS: 'In Progress',
        resolved: 'Resolved',
        Resolved: 'Resolved',
        RESOLVED: 'Resolved',
        rejected: 'Rejected',
        Rejected: 'Rejected',
        REJECTED: 'Rejected',
        pending: 'Pending',
        Pending: 'Pending',
        PENDING: 'Pending',
        reopen: 'Reopen',
        REOPEN: 'Reopen',
        reopened: 'Reopen',
        REOPENED: 'Reopen',
      },
      header: {
        tagline: 'Review and manage complaints assigned to your role',
      },
      dashboard: {
        table: {
          reopenComplaint: 'Reopen Complaint',
          complaintId: 'Complaint ID',
          submittedDate: 'Submitted Date',
          resolvedDate: 'Resolved Date',
          citizenDetails: 'Citizen Details',
          priority: 'Priority',
          taluka: 'Taluka',
          department: 'Department',
          printComplaint: 'Print Complaint',
          status: 'Status',
          pendingDays: 'Pending Days',
          raisedBy: 'Raised By',
          actions: 'Actions',
          complainantDetails: 'Complainant Details',
        },
      },
      priority: {
        low: 'Low',
        LOW: 'Low',
        Low: 'Low',
        medium: 'Medium',
        MEDIUM: 'Medium',
        Medium: 'Medium',
        high: 'High',
        HIGH: 'High',
        High: 'High',
        critical: 'Critical',
        CRITICAL: 'Critical',
        Critical: 'Critical',
      },
      raisedBy: {
        collector: 'Collector',
        citizen: 'Citizen',
        admin: 'Admin',
        na: 'N/A',
      },
      actions: {
        assign: 'Assign',
        assigned: 'Assigned',
      },
      department: {
        "Additional Collector Gadchiroli": "Additional Collector Gadchiroli",
        "Additional Collector Aheri": "Additional Collector Aheri",
        "Deputy Collector MGNREGA": "Deputy Collector MGNREGA",
        "Deputy Collector (Land Acquisition)": "Deputy Collector (Land Acquisition)",
        "Resident Deputy Collector": "Resident Deputy Collector",
        "Deputy District Election Officer (In-Charge)": "Deputy District Election Officer (In-Charge)",
        "District Informatics Officer / Director (I.T.)": "District Informatics Officer / Director (I.T.)",
        "District Mining Officer": "District Mining Officer",
        "SDO Gadchiroli": "SDO Gadchiroli",
        "SDO Aheri": "SDO Aheri",
        "SDO Chamorshi": "SDO Chamorshi",
        "SDO Etapalli": "SDO Etapalli",
        "SDO Kurkheda": "SDO Kurkheda",
        "SDO Sironcha": "SDO Sironcha",
        "SDO Armori": "SDO Armori",
        "SDO Dhanora": "SDO Dhanora",
        "SDO Korchi": "SDO Korchi",
        "SDO Wadsa": "SDO Wadsa",
        "SDO Desaiganj": "SDO Desaiganj",
        "SDO Bhamragad": "SDO Bhamragad",
        "SDO Mulchera": "SDO Mulchera",
        // Tehsil Offices
        "Tehsildar Gadchiroli": "Tehsildar Gadchiroli",
        "Tehsildar Aheri": "Tehsildar Aheri",
        "Tehsildar Armori": "Tehsildar Armori",
        "Tehsildar Chamorshi": "Tehsildar Chamorshi",
        "Tehsildar Dhanora": "Tehsildar Dhanora",
        "Tehsildar Etapalli": "Tehsildar Etapalli",
        "Tehsildar Sironcha": "Tehsildar Sironcha",
        "Tehsildar Korchi": "Tehsildar Korchi",
        "Tehsildar Kurkheda": "Tehsildar Kurkheda",
        "Tehsildar Wadsa": "Tehsildar Wadsa",
        "Tehsildar Desaiganj": "Tehsildar Desaiganj",
        "Tehsildar Bhamragad": "Tehsildar Bhamragad",
        "Tehsildar Mulchera": "Tehsildar Mulchera",
        // Panchayat Samiti / BDO
        "Block Development Officer Gadchiroli": "Block Development Officer Gadchiroli",
        "Block Development Officer Aheri": "Block Development Officer Aheri",
        "Block Development Officer Armori": "Block Development Officer Armori",
        "Block Development Officer Chamorshi": "Block Development Officer Chamorshi",
        "Block Development Officer Dhanora": "Block Development Officer Dhanora",
        "Block Development Officer Etapalli": "Block Development Officer Etapalli",
        "Block Development Officer Sironcha": "Block Development Officer Sironcha",
        "Block Development Officer Korchi": "Block Development Officer Korchi",
        "Block Development Officer Kurkheda": "Block Development Officer Kurkheda",
        "Block Development Officer Wadsa": "Block Development Officer Wadsa",
        "Block Development Officer Desaiganj": "Block Development Officer Desaiganj",
        "Block Development Officer Bhamragad": "Block Development Officer Bhamragad",
        "Block Development Officer Mulchera": "Block Development Officer Mulchera",
        // Short forms just in case
        "BDO Gadchiroli": "BDO Gadchiroli",
        "BDO Aheri": "BDO Aheri",
        "BDO Armori": "BDO Armori",
        "BDO Chamorshi": "BDO Chamorshi",
        "BDO Dhanora": "BDO Dhanora",
        "BDO Etapalli": "BDO Etapalli",
        "BDO Sironcha": "BDO Sironcha",
        "BDO Korchi": "BDO Korchi",
        "BDO Kurkheda": "BDO Kurkheda",
        "BDO Wadsa": "BDO Wadsa",
        "BDO Desaiganj": "BDO Desaiganj",
        "BDO Bhamragad": "BDO Bhamragad",
        "BDO Mulchera": "BDO Mulchera",
        // Panchayat Samiti
        "Panchayat Samiti Gadchiroli": "Panchayat Samiti Gadchiroli",
        "Panchayat Samiti Aheri": "Panchayat Samiti Aheri",
        "Panchayat Samiti Armori": "Panchayat Samiti Armori",
        "Panchayat Samiti Chamorshi": "Panchayat Samiti Chamorshi",
        "Panchayat Samiti Dhanora": "Panchayat Samiti Dhanora",
        "Panchayat Samiti Etapalli": "Panchayat Samiti Etapalli",
        "Panchayat Samiti Sironcha": "Panchayat Samiti Sironcha",
        "Panchayat Samiti Korchi": "Panchayat Samiti Korchi",
        "Panchayat Samiti Kurkheda": "Panchayat Samiti Kurkheda",
        "Panchayat Samiti Wadsa": "Panchayat Samiti Wadsa",
        "Panchayat Samiti Desaiganj": "Panchayat Samiti Desaiganj",
        "Panchayat Samiti Bhamragad": "Panchayat Samiti Bhamragad",
        "Panchayat Samiti Mulchera": "Panchayat Samiti Mulchera"
      },
      taluka: {
        "Gadchiroli": "Gadchiroli",
        "Aheri": "Aheri",
        "Armori": "Armori",
        "Chamorshi": "Chamorshi",
        "Dhanora": "Dhanora",
        "Etapalli": "Etapalli",
        "Sironcha": "Sironcha",
        "Korchi": "Korchi",
        "Kurkheda": "Kurkheda",
        "Wadsa": "Wadsa",
        "Desaiganj": "Desaiganj",
        "Bhamragad": "Bhamragad",
        "Bhamaragad": "Bhamragad",
        "Etapalli (S)": "Etapalli",
        "Mulchera": "Mulchera"
      },
      common: {
        na: 'NA',
      },
      filter: {
        dateFrom: 'From Date',
        dateTo: 'To Date',
      },
      modal: {
        citizenInfo: 'Citizen Information',
        complaintInfo: 'Complaint Information',
        complaintDesc: 'Complaint Description',
        officerNotes: 'Officer Notes',
        citizenPhotos: 'Citizen Photos',
        officerPhotos: 'Officer Resolution Photos',
        noCitizenPhotos: 'No photos uploaded by citizen',
      },
      cards: {
        totalComplaints: 'Total Complaints',
        resolved: 'Resolved',
        pending: 'Pending',
        overdue21Days: 'OverDue 21 Days',
      },
      reports: {
        exportExcel: 'Export to Excel',
        crmReport: 'Daily CRM Report',
        agingReport: 'Aging Report',
        exportPdf: 'Export to PDF',
        schedule: 'Schedule Report',
      },
      analytics: {
        deptPerformance: 'Department Performance Overview',
        slaPerformance: 'SLA Performance Analysis',
        monthlyTrends: 'Monthly Trends',
        priorityDist: 'Priority Distribution',
        slaTarget: 'SLA Target',
        avgResolution: 'Avg Resolution',
        slaBreaches: 'SLA Breaches',
        compliance: 'Compliance Rate',
        excellent: 'Excellent',
        good: 'Good',
        needsImprovement: 'Needs Improvement',
      },
      legend: {
        collectorPriority: 'Collector Raised Priority',
        citizenRaised: 'Raised by Citizen',
      },
      section: {
        complaintsManagement: 'Complaints Management',
        raiseComplaint: 'Raise Complaint',
      },
      emptyState: {
        title: 'No Complaints Found',
        description:
          'There are currently no complaints matching your criteria.',
        suggestion: 'Try adjusting your filters or search terms.',
      },
      pagination: {
        first: 'First',
        previous: 'Previous',
        next: 'Next',
        last: 'Last',
        pageOf: 'Page {{current}} of {{total}}',
      },
      resolutionModal: {
        title: 'Resolve Complaint',
        idLabel: 'ID',
        closingComment: {
          label: 'Closing Comment',
          required: 'Closing Comment *',
          placeholder:
            'Describe how the complaint was resolved, actions taken, and outcome...',
          helpText: 'This comment will be visible to the citizen',
        },
        photos: {
          label: 'Resolution Photos (Optional)',
          uploadPrompt: 'Click to upload resolution photos',
          fileTypes: 'PNG, JPG up to 10MB each',
          selectedLabel: 'Selected files:',
        },
        warning: {
          title: 'Important',
          message:
            'Once resolved, this complaint will be marked as completed. The status dropdown will be disabled permanently.',
        },
        buttons: {
          cancel: 'Cancel',
          resolve: 'Resolve Complaint',
          resolving: 'Resolving...',
        },
      },
      assign: {
        title: 'Assign Complaint',
        subtitle: 'Select department and officer for this complaint',
        selectDepartment: 'Select Department ',
        specialInstructions: 'Special Instructions (Optional)',
        info: 'Assignment will be processed immediately',
        button: 'Assign Now',
        specialInstructionsPlaceholder:
          'Add specific instructions, priority notes, or deadline requirements...',
      },
      complaint: {
        dateSubmitted: 'Date Submitted',
        currentStatus: 'Current Status',
      },
      "Complaint submitted successfully": "Complaint submitted successfully",
      "By": "By",
      "Citizen": "Citizen",
      "Public": "Public",
      "Internal": "Internal",
      "Updated": "Updated",
      'Please assign a department.': 'Please assign a department.',
    },
  },
  mr: {
    translation: {
      // Navigation
      'nav.home': 'मुख्य पान',
      'nav.newComplaint': 'तक्रार नोंदवा',
      'nav.newComplaint.short': 'नोंदणी',
      'nav.trackComplaint': 'तक्रारीची स्थिती पहा',
      'nav.trackComplaint.short': 'तक्रार नोंदवा',
      'nav.login': 'लॉगिन',
      'nav.dashboard': 'डॅशबोर्ड',
      'nav.admin': 'प्रशासन पॅनल',
      'nav.admin': 'प्रशासन पॅनल',
      'nav.logout': 'लॉगआउट',

      // Admin Page - Add User Form
      'admin.form.enterFullName': 'पूर्ण नाव प्रविष्ट करा',
      'admin.form.enterEmail': 'ईमेल प्रविष्ट करा',
      'admin.form.enterUserName': 'वापरकर्ता नाव प्रविष्ट करा',

      // Home Page
      'home.title': 'जिल्हाधिकारी कार्यालय, गडचिरोली',
      'home.subtitle':
        'जिल्हाधिकारी कार्यालय, गडचिरोली नागरिक तक्रार निवारण केंद्र',
      'home.registerCard.title': 'नवीन तक्रार नोंदवा',
      'home.registerCard.description':
        'तुमच्या क्षेत्रातील नागरी समस्यांबद्दल नवीन तक्रार सादर करा',
      'home.registerCard.button': 'सुरू करा',
      'home.complaintStatistics': 'तक्रारींची आकडेवारी',
      'home.totalRegistered': 'एकूण नोंदणी',
      'home.complaintsReceived': 'प्राप्त तक्रारी',
      'home.successfullyResolved': 'यशस्वीरित्या सोडवले',
      'home.complaintsClosed': 'बंद झालेल्या तक्रारी',
      'home.resolutionRate': 'सोडवण्याचा दर',
      'home.successPercentage': 'यश टक्केवारी',
      'home.trackCard.title': 'तुमच्या तक्रारीची स्थिती पहा',
      'home.trackCard.description':
        'तुमच्या सादर केलेल्या तक्रारींची स्थिती तपासा',
      'home.trackCard.button': 'आता ट्रॅक करा',
      'home.trackcard.citizennote': 'नागरिक तक्रार निवारण केंद्र',
      'home.services.title': 'नागरिक सेवा',
      'home.services.subtitle':
        'नागरी समस्या नोंदवण्यासाठी आणि त्यांचा मागोवा घेण्यासाठी आमच्या तक्रार व्यवस्थापन सेवांचा वापर करा',
      'home.process.title': 'ते कसे कार्य करते',
      'home.process.title1': '१',
      'home.process.title2': '२',
      'home.process.title3': '३',
      'home.process.subtitle':
        'आमची सुलभ प्रक्रिया तुमच्या तक्रारी कार्यक्षम आणि पारदर्शकपणे हाताळल्या जातील याची खात्री देते',
      'home.process.step1.title': 'तक्रार नोंदवा',
      'home.process.step1.description':
        'सविस्तर माहिती आणि आधार पुरावे देऊन तक्रार फॉर्म भरा',
      'home.process.step2.title': 'तक्रार क्रमांक मिळवा',
      'home.process.step2.description':
        'तुमच्या तक्रारीच्या प्रगतीवर लक्ष ठेवण्यासाठी एक अद्वितीय ट्रॅकिंग आयडी मिळवा',
      'home.process.step3.title': 'प्रगती ट्रॅक करा',
      'home.process.step3.description':
        'रिअल-टाईम अपडेट्स पहा आणि निराकरण स्थितीबद्दल सूचना मिळवा',
      'home.contact.title': 'मदत हवी आहे का?',
      'home.contact.subtitle':
        'तुमच्या तक्रारी किंवा इतर चौकशींसाठी आमच्या समर्थन टीमशी संपर्क साधा',
      'home.contact.phone': 'फोन',
      'home.contact.email': 'ईमेल',
      'home.contact.subtitle':
        'तुमच्या तक्रारी किंवा इतर चौकशींसाठी आमच्या समर्थन टीमशी संपर्क साधा',
      'home.contact.phone': 'फोन सहाय्य',
      'home.contact.phoneDesc': 'थेट फोन सहाय्य',
      'home.contact.email': 'ईमेल सहाय्य',
      'home.contact.emailDesc': 'तुमचे प्रश्न आम्हाला पाठवा',
      'home.contact.whatsapp': 'व्हॉटस्अँप चॅट',
      'home.contact.whatsappDesc': 'झटपट चॅट सहाय्य',
      'home.contact.whatsappNote': 'QR स्कॅन करा किंवा चॅट सुरू करा',
      'home.contact.startChat': 'चॅट सुरू करा',
      'home.weblink.1': 'गडचिरोली जिल्हा संकेतस्थळ',
      'home.weblink.2': 'संपर्क यादी (अधिकारी)',
      'home.weblink.3': 'आपल सरकार पोर्टल',
      'home.footer': 'कॉपीराइट © २०२५. सर्व हक्क राखीव.',
      'header.Shri. Devendra Fadnavis': 'श्री.देवेंद्र फडणवीस',
      'header.cm.note': 'मुख्यमंत्री, महाराष्ट्र राज्य  ',
      'header.cm.note1': 'तथा पालकमंत्री, गडचिरोली',
      'header.Shri. Ashish Jaiswal': 'अ‍ॅड.श्री.आशिष जैसवाल',
      'header.Co-Guardian Minister, Gadchiroli':
        'राज्य मंत्री, महाराष्ट्र राज्य,',
      'header.note2': 'तथा सहपालकमंत्री, गडचिरोली',
      'header.pulic.request': '  जननिवेदन',
      'header.public.note': 'आपली मते व तक्रारी थेट प्रशासनापर्यंत',

      // New Complaint Page

      'complaint.new.title': 'नवीन तक्रार नोंदवा',
      'complaint.new.subtitle': 'तुमची तक्रार नोंदवण्यासाठी खालील फॉर्म भरा',
      'complaint.new.complaintdetail': 'तक्रारी तपशील',
      'complaint.form./2000': '/२०००',
      'complaint.form.name': 'पूर्ण नाव',
      'complaint.form.mobile': 'मोबाईल क्रमांक',
      'complaint.form.pincode': 'पिनकोड',
      'complaint.form.email': 'ई-मेल आयडी',
      'complaint.form.dob': 'जन्मतारीख',
      'complaint.form.age': 'वय',
      'complaint.form.gender': 'लिंग',
      'complaint.form.male': 'पुरुष',
      'complaint.form.female': 'महिला',
      'complaint.form.prepernottosay': 'सांगणे टाळतो/टाळते',
      'complaint.form.providedetailed':
        'कृपया तुमच्या तक्रारीबद्दल सविस्तर माहिती द्या',
      'complaint.form.personalinformation': 'वैयक्तिक माहिती',
      'complaint.form.choosedepartment': 'विभाग निवडा',
      'complaint.form.note':
        'JPG, PNG, PDF, DOC (प्रत्येक १०MB पर्यंत, ५ फाइल्सपर्यंत)',
      'complaint.form.address': 'संपूर्ण पत्ता',
      'complaint.form.submitnote':
        'अस्वीकृती - हा फॉर्म सबमिट करून, तुम्ही अचूक माहिती देण्यास सहमत आहात',
      'complaint.form.submitcomplaint': 'तक्रार सबमिट करा',
      'complaint.form.village': 'गाव',
      'complaint.form.taluka': ' तालुका',
      'complaint.form.category': 'तक्रार प्रकार',
      'complaint.form.Department': 'विभाग',
      'complaint.form.description': 'तक्रारीचे वर्णन',
      'complaint.form.photo': 'फोटो अपलोड करा',
      'complaint.form.ChooseFiles': 'फाइल्स निवडा',
      'complaint.form.submit': 'तक्रार सबमिट करा',
      'complaint.form.submitting': 'सबमिट होत आहे...',
      'complaint.categories.water': 'पाणीपुरवठा',
      'complaint.categories.road': 'रस्ता व परिवहन',
      'complaint.categories.electricity': 'वीजपुरवठा',
      'complaint.categories.sanitation': 'स्वच्छता',
      'complaint.categories.healthcare': 'आरोग्य सेवा',
      'complaint.categories.education': 'शिक्षण',
      'complaint.categories.other': 'इतर',
      'complaint.categories.revenu': 'महसूल विभाग',
      'complaint.categories.police': 'पोलीस विभाग',
      'complaint.categories.healtdpt': 'आरोग्य विभाग',
      'complaint.categories.educationDpt': 'शिक्षण विभाग',
      'complaint.categories.food': 'अन्न व नागरी पुरवठा विभाग',
      'complaint.categories.SocialWelfare': 'सामाजिक न्याय विभाग',
      'complaint.categories.labourDpt': 'कामगार विभाग',
      'complaint.categories.transportDpt': 'परिवहन विभाग',
      'complaint.categories.electricityDpt': 'वीज विभाग',
      'complaint.success.title': 'तक्रार यशस्वीरीत्या नोंदवली!',
      'complaint.success.id': 'तुमचा तक्रार क्रमांक:',
      'complaint.success.note':
        'कृपया हा आयडी जतन करा, तक्रारीची स्थिती पाहण्यासाठी.',
      'complaint.success.close': 'बंद करा',
      'complaint.CopyID': 'आयडी कॉपी करा',
      'complaint.RaiseNewcomplaint': 'नवीन तक्रार नोंदवा',
      'complaint.Track Complaint': 'ट्रॅक तक्रार',
      'complaint.track': '✅ क्लिपबोर्डवर कॉपी केले!',
      'otp.title': 'ओटीपी पडताळणी',
      'otp.sentTo': 'येथे पाठवलेला ६ अंकी ओटीपी प्रविष्ट करा',
      'otp.expired': 'ओटीपी कालबाह्य झाला',
      'otp.expiresIn': 'ओटीपी कालबाह्य होईल',
      'otp.verifying': 'पडताळणी होत आहे...',
      'otp.verify': 'ओटीपी सत्यापित करा',
      'otp.didNotReceive': 'ओटीपी मिळाला नाही का?',
      'otp.resend': 'ओटीपी पुन्हा पाठवा',
      'otp.back': 'मागे वळा',
      'otp.success.title': 'सत्यापित',
      'otp.success.message': 'तुमचा ओटीपी यशस्वीरित्या सत्यापित झाला आहे!',
      'otp.mobile': 'मोबाईल:',

      //Searchbar placeholder
      'Search by Officer, Contact, Role or Department...': 'अधिकारी, संपर्क, भूमिका किंवा विभाग द्वारा खोजें...',
      'Add public comment...': 'सार्वजनिक टिप्पणी जोड़ें...',
      'Reopen Reason': 'पुन्हा उघडण्याचे कारण',
      'Please enter a valid email address.': 'कृपया वैध ईमेल पत्ता प्रविष्ट करा',
      'Please attahch at least one file': 'कृपया किमान एक फाईल संलग्न करा',
      //How It Works
      'howItWorks.title': 'हे कसे कार्य करते',
      'howItWorks.steps.submitComplaint.title': 'तक्रार सबमिट करा',
      'howItWorks.steps.submitComplaint.description':
        'तुमची माहिती भरण्यासाठी फॉर्म भरा',
      'howItWorks.steps.getComplaintID.title': 'तक्रारीचा आयडी मिळवा',
      'howItWorks.steps.getComplaintID.description':
        'अद्वितीय ट्रॅकिंग नंबर मिळवा',
      'howItWorks.steps.officialReview.title': 'अधिकारी तपासणी',
      'howItWorks.steps.officialReview.description':
        'सरकारी अधिकारी तक्रारीचे प्रक्रियाकरण करतात',
      'howItWorks.steps.trackProgress.title': 'स्थिती तपासा',
      'howItWorks.steps.trackProgress.description': 'ऑनलाइन कधीही स्थिती तपासा',
      'howItWorks.bottomNote': '✅ नागरिकांसाठी लॉगिन आवश्यक नाही!',

      // Track Complaint Page
      'track.title': 'तुमच्या तक्रारीची स्थिती पहा',
      'track.titlenote': 'तक्रारींचा मागोवा प्रणाली',
      'track.subtitle': 'सध्याची स्थिती तपासण्यासाठी तुमचा तक्रार क्रमांक टाका',
      'track.form.searchmethod': 'शोध पद्धत निवडा:',
      'track.form.id': 'तक्रार क्रमांक',
      'track.form.mobilenumber': 'मोबाईल क्रमांक',
      'track.form.enterComplaintId': 'तक्रार क्रमांक टाका',
      'track.form.placeholder': 'तुमचा तक्रार क्रमांक टाका ',
      'track.form.placeholdermobile': 'तुमचा मोबाईल नंबर टाका ',
      'track.form.trackbymobile': 'मोबाईल नंबरने ट्रॅक करा',
      'track.form.pleaseEnter': 'कृपया तक्रार क्रमांक टाका',
      'track.form.trackbyid': 'आयडीद्वारे ट्रॅक करा',
      'track.form.demotesting': 'चाचणीसाठीचा डेमो डेटा:',
      'track.form.search': 'शोधा',
      'track.form.searching': 'शोधत आहे...',
      'track.form.trackButton': 'तक्रारीची स्थिती पाहा',
      'track.notFound':
        'तक्रार सापडली नाही. कृपया तुमचा आयडी तपासा आणि पुन्हा प्रयत्न करा.',
      'track.demo.title': 'चाचणीसाठी डेमो तक्रार क्रमांक:',
      'track.demo.try': 'प्रयत्न करा: CMP001 किंवा CMP002',
      'track.demo.sample': 'प्रात्यक्षिकासाठी नमुना तक्रारी',
      'track.progress.title': 'तुमची प्रगती ट्रॅक करा',
      'track.steps.enter.title': 'तक्रार क्रमांक टाका',
      'track.steps.enter.description': 'तुमचा अद्वितीय ट्रॅकिंग नंबर वापरा',
      'track.steps.view.title': 'स्थिती पहा',
      'track.steps.view.description': 'सध्याची प्रगती तात्काळ तपासा',
      'track.steps.updates.title': 'अपडेट्स मिळवा',
      'track.steps.updates.description': 'रिअल-टाइम सूचना प्राप्त करा',
      'track.steps.resolution.title': 'निराकरण ट्रॅक करा',
      'track.steps.resolution.description': 'पूर्ण होईपर्यंत निरीक्षण करा',
      'track.realtime': '🔍 रिअल-टाइम तक्रार ट्रॅकिंग!',
      'track.error.mobileInIdField': "असे दिसते की तुम्ही मोबाईल नंबर प्रविष्ट केला आहे. कृपया शोधण्यासाठी 'मोबाईल नंबर' निवडा.",
      'track.error.invalidId': "कृपया वैध तक्रार आयडी प्रविष्ट करा.",
      'track.details.title': 'तक्रारीचे तपशील',
      'track.details.id': 'तक्रार क्रमांक',
      'track.details.basicInfo': 'मूलभूत माहिती',
      'track.details.name': 'नाव',
      'track.details.mobile': 'मोबाइल',
      'track.details.address': 'पत्ता',
      'track.details.village': 'गाव',
      'track.details.taluka': 'तालुका',
      'track.details.category': 'प्रकार',
      'track.details.description': 'वर्णन',
      'track.details.status': 'स्थिती',
      'track.details.submitted': 'सादर केले',
      'track.details.applicant': 'अर्जदाराचे तपशील',
      'track.details.department': 'विभाग आणि नियुक्ती',
      'track.details.departmentLabel': 'विभाग',
      'track.details.assignedTo': 'यांना सोपवले',
      'track.timeline.title': 'स्थिती टाइमलाइन',
      'track.Found': 'मोबाईलसाठी',
      'track.ComplaintsforMobile': 'तक्रारी आढळल्या:',
      'track.ViewDetails': 'तपशील पहा',
      'track.Scrolltoseeall': 'सर्व पाहण्यासाठी स्क्रोल करा',
      'track.id': 'आयडी',
      'TRACK.ID': 'आयडी:',
      'track.BasicInformation': 'मूलभूत माहिती',
      'track.Description': ' वर्णन',
      'track.Village': 'गाव',
      'track.Taluka': 'तालुका',
      'track.Applicant Details': 'अर्जदाराचे तपशील',
      'track.Citizen Attachments': ' नागरिक संलग्नक',
      'track.Nocitizenattachments': '  कोणतेही नागरिक संलग्नक नाहीत',
      'track.note1': ' या तक्रारीसोबत नागरिकाने कोणत्याही फाईल जोडल्या नाहीत.',
      'track.Officer Attachments': ' अधिकारी संलग्नक',
      trackNoofficerattachments: ' अधिकारी संलग्न नाहीत',
      'track.note2':
        'अधिकाऱ्याने अद्याप कोणतेही रिझोल्यूशन फोटो जोडलेले नाहीत.',
      'track.Department & Assignment': ' विभाग ',
      'track.Department': ' विभाग',
      'track.Assigned To': ' यांना नियुक्त केले',
      'track.Submitted Date': 'सबमिट केलेली तारीख',
      'track.Status Timeline': 'स्थिती टाइमलाइन',
      'track.Officer Comments & Updates': ' अधिकारी टिप्पण्या आणि अद्यतने',
      'track.Public Comment': 'सार्वजनिक टिप्पणी',
      'track.No public comments from officers yet':
        ' अधिकाऱ्यांकडून अद्याप कोणतीही सार्वजनिक प्रतिक्रिया नाही',
      'track.note3':
        ' तुमच्या तक्रारीवर काम करत असताना अधिकारी येथे अपडेट्स पोस्ट करतील.',
      'track.note4': 'टीप:',
      'track.note4info':
        'येथे फक्त अधिकाऱ्यांच्या सार्वजनिक टिप्पण्या दाखवल्या आहेत.',
      'track.rating': 'तुमचे रेटिंग',
      'track.ratenow': 'या तक्रार निराकरणाचे मूल्यांकन करा',
      'track.rate': 'तुमचे रेटिंग',
      'track.Addyourfeedback ': ' तुमचा अभिप्राय जोडा ',
      'track.Cancel': ' रद्द करा',
      'track.Writeyourcommenthere...': ' तुमची प्रतिक्रिया इथे लिहा...',
      'track.RateResolution': 'रेट निराकरण',
      'track.Reopen Complaint': 'तक्रार पुन्हा उघडा',
      'track.Submitting...': 'सबमिट करत आहे...',
      'track.Submit': 'सबमिट करा',
      'Excellent': 'उत्कृष्ट',
      'Good': 'चांगले',
      'Average': 'सरासरी',
      'Poor': 'वाईट',
      'Very Poor': 'खूप वाईट',
      'track.Copied!': ' कॉपी केले!',
      'track.rating.yourRating': 'तुमचे रेटिंग',
      'track.rating.title': 'निराकरण गुणवत्तेचे मूल्यांकन करा',
      'track.rating.selectStar': 'रेटिंग निवडा',
      'track.rating.commentPlaceholder': 'निराकरणाबद्दल टिप्पणी जोडा (पर्यायी)...',
      'track.rating.submit': 'रेटिंग सबमिट करा',
      'track.rating.success': 'तुमच्या अभिप्रायाबद्दल धन्यवाद!',
      'track.rating.error': 'रेटिंग सबमिट करण्यात अयशस्वी. कृपया पुन्हा प्रयत्न करा.',
      'track.rating.pleaseSelect': 'कृपया रेटिंग निवडा',

      // Roles
      'roles.ADMIN': 'प्रशासन',
      'roles.COLLECTOR': 'जिल्हाधिकारी',
      'roles.DEPUTY_COLLECTOR_MGNREGA': 'उपजिल्हाधिकारी (रोहयो)',
      'roles.OFFICER': 'अधिकारी',
      'roles.TALUKA_OFFICER': 'तालुका अधिकारी',

      // Login Page

      'login.title': 'अधिकारी पोर्टल लॉगिन',
      'login.subtitle': 'तक्रारी व्यवस्थापित करण्यासाठी साइन इन करा',
      'login.forcitizen': 'नागरिकांसाठी',
      'login.citizennote':
        'नागरिकांना खाती तयार न करता थेट तक्रारी सादर करण्याची आणि ट्रॅक करण्याची सुविधा आहे.',
      'login.noterequired': 'लॉगिन आवश्यक नाही!',
      'login.GovernmentPortal': 'अधिकारी पोर्टल',
      'login.governmentportalnote': 'फक्त अधिकृत व्यक्ती',
      'login.GovernmentStaffAccessOnly': 'फक्त सरकारी कर्मचारी प्रवेश',
      'login.accessnote':
        'हे पोर्टल केवळ अधिकृत सरकारी अधिकाऱ्यांपुरते मर्यादित आहे. सुरक्षेच्या उद्देशाने सर्व क्रियाकलापांचे लॉगिंग आणि निरीक्षण केले जाते.',
      'login.notfillpassword': 'तुमचा पासवर्ड टाका',
      'login.notfillemail': 'तुमचा अधिकृत ई-मेल प्रविष्ट करा',
      'login.AreyouaCitizen': 'तुम्ही नागरिक आहात का?',
      'login.citizennote':
        'नागरिकांना खाती तयार न करता थेट तक्रारी सादर करण्याची आणि ट्रॅक करण्याची सुविधा आहे.',
      'login.citizenportal': 'नागरिक पोर्टलवर जा',
      'login.notfillusername': 'तुमचा वापरकर्ता नाव प्रविष्ट करा',
      'login.email': 'ईमेल पत्ता',
      'login.password': 'पासवर्ड',
      'login.signin': 'साइन इन',
      'login.signing': 'साइन इन करत आहे...',
      'login.error': 'अवैध ईमेल किंवा पासवर्ड',
      'login.demo.title': 'डेमो लॉगिन माहिती:',
      'login.demo.officer': 'विभाग अधिकारी',
      'login.demo.taluka': 'तालुका अधिकारी',
      'login.demo.collector': 'जिल्हाधिकारी',
      'login.demo.admin': 'प्रशासक',
      'login.username': 'युजरनेम',
      'login.forgotPassword': 'पॅसवर्ड रीसेट करा',
      'login.forgotnote': 'तुमचा ईमेल किंवा वापरकर्ता नाव प्रविष्ट करा',
      'login.placeholderresetpassword': 'ईमेल किंवा युजरनेम',
      'login.cancel': ' रद्द करा',
      'login reset': 'रीसेट ',
      'Verify OTP': 'OTP सत्यापित करें',
      'Enter OTP': 'OTP दर्ज करें',
      'Resend OTP': 'OTP पुनः भेजें',

      // Dashboard
      'dashboard.title': 'अधिकारी डॅशबोर्ड',
      'dashboard.welcome': 'पुन्हा स्वागत',
      'dashboard.stats.total': 'एकूण तक्रारी',
      'dashboard.stats.pending': 'प्रलंबित',
      'dashboard.stats.progress': 'प्रक्रियेत',
      'dashboard.stats.resolved': 'निराकरण केलेले',
      'dashboard.search.placeholder': 'तक्रारी शोधा...',
      'Search by Officer, Contact, Role or Department...':
        'अधिकारी, संपर्क, भूमिका किंवा विभागाद्वारे शोधा...',
      'dashboard.search.advanced': 'प्रगत शोध',
      'dashboard.filter.status': 'स्थिती',
      'dashboard.filter.category': 'प्रकार',
      'dashboard.filter.priority': 'प्राथमिकता',
      'dashboard.filter.assignedTo': 'नियुक्त केले',
      'dashboard.filter.age': 'तक्रारीचे वय',
      'dashboard.filter.village': 'गाव',
      'dashboard.filter.clear': 'फिल्टर साफ करा',
      'dashboard.filter.save': 'शोध जतन करा',
      'dashboard.table.id': 'आयडी',
      'dashboard.table.citizen': 'नागरिक',
      'dashboard.table.category': 'प्रकार',
      'dashboard.table.status': 'स्थिती',
      'dashboard.table.priority': 'प्राथमिकता',
      'dashboard.table.date': 'तारीख',
      'dashboard.table.actions': 'कृती',
      'dashboard.actions.view': 'तपशील पहा',
      'dashboard.actions.assign': 'नियुक्त करा',
      'dashboard.actions.update': 'स्थिती अपडेट करा',

      // Status values
      'status.submitted': 'सादर केले',
      'status.inProgress': 'प्रक्रियेत',
      'status.resolved': 'निराकरण केलेले',
      'status.escalated': 'वाढवले',

      // Priority values
      'priority.low': 'कमी',
      'priority.medium': 'मध्यम',
      'priority.high': 'उच्च',
      'priority.critical': 'गंभीर',

      // Common
      'common.loading': 'लोड करत आहे...',
      'common.save': 'जतन करा',
      'common.cancel': 'रद्द करा',
      'common.close': 'बंद करा',
      'common.delete': 'हटवा',
      'common.edit': 'संपादित करा',
      'common.add': 'जोडा',
      'common.search': 'शोधा',
      'common.filter': 'फिल्टर',
      'common.export': 'निर्यात',
      'common.refresh': 'रिफ्रेश',
      'common.language': 'भाषा',

      // Additional form placeholders and validation
      'form.selectCategory': 'प्रकार निवडा',
      'form.selectVillage': 'गाव/तालुका निवडा',
      'form.photoUploadNote':
        'तुमच्या तक्रारीशी संबंधित फोटो अपलोड करा (JPG, PNG, कमाल 5MB)',
      'form.submitAnother': 'दुसरी तक्रार सादर करा',

      // Additional workflow items
      'flowMenu.citizenLogin': 'नागरिक लॉगिन',
      'flowMenu.registeredComplaint': 'नोंदणीकृत तक्रार',
      'flowMenu.verifyComplaint': 'तक्रार सत्यापित करा',
      'flowMenu.trackComplaint': 'तक्रारीची स्थिती पाहा',

      // Dashboard detail modal
      'dashboard.modal.complaint': 'तक्रार',
      'dashboard.modal.actionTimeline': 'कृती टाइमलाइन',
      'dashboard.modal.commentsUpdates': 'टिप्पण्या आणि अपडेट्स',
      'dashboard.modal.citizenAttachments': 'नागरिक जोडलेले',
      'dashboard.modal.officerResolutionPhotos': 'अधिकारी निराकरण फोटो',
      'dashboard.modal.noTimeline': 'कोणतीही टाइमलाइन उपलब्ध नाही',
      'dashboard.modal.noComments': 'अद्याप कोणतीही टिप्पणी नाही',
      'dashboard.modal.addFirstComment': 'पहिली टिप्पणी जोडा',
      'dashboard.modal.public': 'सार्वजनिक',
      'dashboard.modal.internal': 'अंतर्गत',
      'dashboard.modal.view': 'पहा',
      'dashboard.modal.download': 'डाउनलोड करा',
      'dashboard.modal.close': 'बंद करा',
      'dashboard.modal.specialInstructions': 'विशेष सूचना',
      'dashboard.modal.assignmentInfo': 'नियुक्ती माहिती',
      'dashboard.modal.assignedTo': 'नियुक्त केले',
      'dashboard.modal.assignmentDate': 'नियुक्ती तारीख',
      'dashboard.modal.detailsOfIssue': 'समस्येचे तपशील:',
      'dashboard.modal.location': 'स्थान:',
      'dashboard.modal.reportedDate': 'अहवाल दिलेली तारीख:',
      'dashboard.modal.contact': 'संपर्क:',
      'dashboard.modal.assignedDepartment': 'नियुक्त विभाग:',
      'dashboard.modal.verified': '✓ सत्यापित',
      'dashboard.modal.resolutionEvidence': '✓ निराकरण पुरावा',
      'dashboard.modal.noPhotos': 'नागरिकाने कोणतेही फोटो अपलोड केले नाहीत',
      'dashboard.modal.noResolutionPhotos':
        'अधिकारीने कोणतेही निराकरण फोटो अपलोड केले नाहीत',
      'dashboard.modal.uploadedByCitizen': 'नागरिकाने अपलोड केले',
      'dashboard.modal.uploadedByOfficer': 'अधिकारीने अपलोड केले',
      'dashboard.modal.unknownSize': 'अज्ञात आकार',
      'dashboard.modal.by': 'याने:',
      'dashboard.modal.dashboard': 'डॅशबोर्ड',
      'dashboard.modal.gadchiroliDistrict': 'जिल्हा गडचिरोली',
      'dashboard.welcome.user': 'स्वागत आहे,',
      'dashboard.welcome.manageComplaints':
        'नागरिक तक्रारी कार्यक्षमतेने व्यवस्थापित करा आणि सोडवा',
      'dashboard.welcome.overseeComplaints':
        'तुमच्या तालुका क्षेत्रातील तक्रारींवर लक्ष ठेवा',
      'dashboard.welcome.monitorComplaints':
        'गंभीर आणि वाढवलेल्या तक्रारींवर लक्ष ठेवा',
      'dashboard.timeline.statusUpdated': 'स्थिती अपडेट केली',
      'dashboard.timeline.priorityUpdated': 'प्राधान्य अपडेट केले',
      'dashboard.timeline.complaintSubmitted': 'तक्रार सादर केली',
      'dashboard.timeline.complaintAssigned': 'तक्रार नियुक्त केली',
      'dashboard.timeline.complaintResolved': 'तक्रार सोडवली',
      'dashboard.timeline.complaintRejected': 'तक्रार नाकारली',
      'dashboard.timeline.commentAdded': 'टिप्पणी जोडली',
      'dashboard.timeline.documentUploaded': 'दस्तऐवज अपलोड केला',
      'dashboard.timeline.actionTaken': 'कृती घेतली',
      'dashboard.timeline.complaintReopened': 'तक्रार पुन्हा उघडली',
      'dashboard.timeline.statusUpdatedNote': 'स्थिती अपडेट केली:',
      'dashboard.timeline.priorityChangePattern': 'प्राधान्यक्रम {{from}} वरून {{to}} बदलला',
      'dashboard.common.pleaseLogin':
        'कृपया डॅशबोर्डमध्ये प्रवेश करण्यासाठी लॉग इन करा.',
      'dashboard.common.logoutConfirm': 'तुम्ही लॉगआउट करू इच्छिता?',
      'dashboard.common.user': 'वापरकर्ता',
      'dashboard.common.officer': 'अधिकारी',
      'dashboard.common.system': 'सिस्टम',
      'dashboard.common.citizen': 'नागरिक',
      'dashboard.header.district': 'जिल्हा गडचिरोली',
      'dashboard.header.user': 'वापरकर्ता',
      'accessibility.fontSize.increase': 'फॉन्ट आकार वाढवा',
      'accessibility.fontSize.normal': 'सामान्य फॉन्ट आकार',
      'accessibility.fontSize.decrease': 'फॉन्ट आकार कमी करा',
      'accessibility.fontSize.extraLarge': 'अतिरिक्त मोठा फॉन्ट आकार',
      'accessibility.language.switchToEnglish': 'इंग्रजीवर स्विच करा',
      'accessibility.language.switchToMarathi': 'मराठीवर स्विच करा',
      'dashboard.comments.addComment': 'टिप्पणी जोडा',
      'dashboard.comments.addPublicComment': 'सार्वजनिक टिप्पणी जोडा...',
      'dashboard.comments.addInternalComment': 'अंतर्गत टिप्पणी जोडा...',
      'dashboard.comments.send': 'पाठवा',
      'dashboard.comments.attachFile': 'फाइल संलग्न करा',
      'dashboard.comments.publicCommentAdded': 'सार्वजनिक टिप्पणी जोडली',
      'dashboard.comments.internalCommentAdded': 'अंतर्गत टिप्पणी जोडली',
      'dashboard.comments.post': 'पोस्ट करा',

      // Admin Page - navigation
      'admin.title': 'प्रशासनिक डॅशबोर्ड',
      'admin.pleaseLogin':
        'कृपया प्रशासनिक डॅशबोर्डमध्ये प्रवेश करण्यासाठी लॉग इन करा.',
      'admin.nav.dashboard.label': 'विश्लेषण डॅशबोर्ड',
      'admin.nav.dashboard.description':
        'प्रणाली मेट्रिक्स आणि कार्यक्षमता पहा',
      'admin.nav.reports.label': 'उन्नत अहवाल',
      'admin.nav.reports.description': 'सविस्तर विश्लेषणात्मक अहवाल तयार करा',
      'admin.nav.officers.label': 'वापरकर्ते व्यवस्थापित करा',
      'admin.nav.officers.description':
        'प्रणालीतील वापरकर्ते जोडा, संपादा आणि व्यवस्थापित करा',

      // Admin Page - dashboard cards & sections
      'admin.cards.totalComplaints': 'एकूण तक्रारी',
      'admin.cards.resolved': 'सोडवलेल्या',
      'admin.cards.pending': 'प्रलंबित',
      'admin.cards.overdue21Days': 'उर्वरित (२१ दिवस)',
      'admin.section.complaintsManagement': 'तक्रार व्यवस्थापन',
      'admin.section.raiseComplaint': 'तक्रार नोंदवा',
      'admin.search.placeholder':
        'आयडी, नाव इत्यादीने तक्रारी शोधा...',

      // Admin Page - complaint detail modal
      'admin.modal.complaintDescription': 'तक्रार वर्णन',
      'admin.modal.officerNotes': 'अधिकारी नोंदी',
      'admin.modal.actionTimeline': 'कृती टाइमलाइन',
      'admin.modal.noTimeline': 'कोणतीही टाइमलाइन उपलब्ध नाही',
      'admin.modal.close': 'बंद करा',
      'admin.modal.noDescription': 'या तक्रारीसाठी कोणतेही वर्णन उपलब्ध नाही.',

      //Register Complaint Page
      'Note:- If your are a government employee, please do not raise your service related complaints here. Raise it with your conserned department.':
        'टीप: आपण सरकारी कर्मचारी असाल, तर कृपया आपल्या सेवेशी संबंधित तक्रारी येथे नोंदवू नका. अशा तक्रारी संबंधित विभागाकडे नोंदवा.',

      status: {
        allStatus: 'सर्व स्थिती',
        new: 'नवीन',
        NEW: 'नवीन',
        inProgress: 'प्रक्रियेत',
        In_Progress: 'प्रक्रियेत',
        IN_PROGRESS: 'प्रक्रियेत',
        resolved: 'निराकरण झाले',
        Resolved: 'निराकरण झाले',
        RESOLVED: 'निराकरण झाले',
        rejected: 'नाकारले',
        Rejected: 'नाकारले',
        REJECTED: 'नाकारले',
        pending: 'प्रलंबित',
        Pending: 'प्रलंबित',
        PENDING: 'प्रलंबित',
        reopen: 'पुन्हा उघडा',
        REOPEN: 'पुन्हा उघडा',
        reopened: 'पुन्हा उघडा',
        REOPENED: 'पुन्हा उघडा',
      },
      header: {
        tagline: 'तुमच्या भूमिकेशी संबंधित तक्रारींची आढावा आणि व्यवस्थापन करा',
      },
      dashboard: {
        table: {
          complainantDetails: 'तक्रारदार माहिती',
          complaintId: 'तक्रार आयडी',
          submittedDate: 'सबमिट तारीख',
          printComplaint: 'तक्रार छापा',
          resolvedDate: 'निराकरण तारीख',
          citizenDetails: 'नागरिक माहिती',
          priority: 'प्राधान्य',
          taluka: 'तालुका',
          department: 'विभाग',
          status: 'स्थिती',
          pendingDays: 'प्रलंबित दिवस',
          raisedBy: 'नोंदवणारा',
          actions: 'क्रिया',
          reopenComplaint: 'तक्रार पुन्हा उघडा',
        },
      },
      priority: {
        Medium: 'मध्यम',
        MEDIUM: 'मध्यम',
        medium: 'मध्यम',
        High: 'उच्च',
        HIGH: 'उच्च',
        high: 'उच्च',
        Low: 'कमी',
        LOW: 'कमी',
        low: 'कमी',
        Critical: 'गंभीर',
        CRITICAL: 'गंभीर',
        critical: 'गंभीर',
      },
      raisedBy: {
        collector: 'कलेक्टर',
        citizen: 'नागरिक',
        admin: 'प्रशासक',
        na: 'नाही',
      },
      actions: {
        assign: 'नोंदवा',
        assigned: 'नोंदवलेले',
      },
      department: {
        "Additional Collector Gadchiroli": "अप्पर जिल्हाधिकारी गडचिरोली",
        "Additional Collector Aheri": "अप्पर जिल्हाधिकारी अहेरी",
        "Deputy Collector MGNREGA": "उपजिल्हाधिकारी, मनरेगा",
        "Deputy Collector (Land Acquisition)": "उपजिल्हाधिकारी (भूसंपादन)",
        "Resident Deputy Collector": "निवासी उपजिल्हाधिकारी",
        "Deputy District Election Officer (In-Charge)": "उप जिल्हा निवडणूक अधिकारी (प्रभारी)",
        "District Informatics Officer / Director (I.T.)": "जिल्हा सूचना विज्ञान अधिकारी / संचालक (आय.टी.)",
        "District Mining Officer": "जिल्हा खनिकर्म अधिकारी",
        "SDO Gadchiroli": "उपविभागीय अधिकारी गडचिरोली",
        "SDO Aheri": "उपविभागीय अधिकारी अहेरी",
        "SDO Chamorshi": "उपविभागीय अधिकारी चामोर्शी",
        "SDO Etapalli": "उपविभागीय अधिकारी एटापल्ली",
        "SDO Kurkheda": "उपविभागीय अधिकारी कुरखेडा",
        "SDO Sironcha": "उपविभागीय अधिकारी सिरोंचा",
        "SDO Armori": "उपविभागीय अधिकारी आरमोरी",
        "SDO Dhanora": "उपविभागीय अधिकारी धानोरा",
        "SDO Korchi": "उपविभागीय अधिकारी कोरची",
        "SDO Wadsa": "उपविभागीय अधिकारी वडसा",
        "SDO Desaiganj": "उपविभागीय अधिकारी देसाईगंज",
        "SDO Bhamragad": "उपविभागीय अधिकारी भामरागड",
        "SDO Mulchera": "उपविभागीय अधिकारी मूलचेरा",
        // Tehsil Offices
        "Tehsildar Gadchiroli": "तहसीलदार गडचिरोली",
        "Tehsildar Aheri": "तहसीलदार अहेरी",
        "Tehsildar Armori": "तहसीलदार आरमोरी",
        "Tehsildar Chamorshi": "तहसीलदार चामोर्शी",
        "Tehsildar Dhanora": "तहसीलदार धानोरा",
        "Tehsildar Etapalli": "तहसीलदार एटापल्ली",
        "Tehsildar Sironcha": "तहसीलदार सिरोंचा",
        "Tehsildar Korchi": "तहसीलदार कोरची",
        "Tehsildar Kurkheda": "तहसीलदार कुरखेडा",
        "Tehsildar Wadsa": "तहसीलदार वडसा",
        "Tehsildar Desaiganj": "तहसीलदार देसाईगंज",
        "Tehsildar Bhamragad": "तहसीलदार भामरागड",
        "Tehsildar Mulchera": "तहसीलदार मूलचेरा",
        // Panchayat Samiti / BDO
        "Block Development Officer Gadchiroli": "गट विकास अधिकारी गडचिरोली",
        "Block Development Officer Aheri": "गट विकास अधिकारी अहेरी",
        "Block Development Officer Armori": "गट विकास अधिकारी आरमोरी",
        "Block Development Officer Chamorshi": "गट विकास अधिकारी चामोर्शी",
        "Block Development Officer Dhanora": "गट विकास अधिकारी धानोरा",
        "Block Development Officer Etapalli": "गट विकास अधिकारी एटापल्ली",
        "Block Development Officer Sironcha": "गट विकास अधिकारी सिरोंचा",
        "Block Development Officer Korchi": "गट विकास अधिकारी कोरची",
        "Block Development Officer Kurkheda": "गट विकास अधिकारी कुरखेडा",
        "Block Development Officer Wadsa": "गट विकास अधिकारी वडसा",
        "Block Development Officer Desaiganj": "गट विकास अधिकारी देसाईगंज",
        "Block Development Officer Bhamragad": "गट विकास अधिकारी भामरागड",
        "Block Development Officer Mulchera": "गट विकास अधिकारी मूलचेरा",
        // Short forms just in case
        "BDO Gadchiroli": "गट विकास अधिकारी गडचिरोली",
        "BDO Aheri": "गट विकास अधिकारी अहेरी",
        "BDO Armori": "गट विकास अधिकारी आरमोरी",
        "BDO Chamorshi": "गट विकास अधिकारी चामोर्शी",
        "BDO Dhanora": "गट विकास अधिकारी धानोरा",
        "BDO Etapalli": "गट विकास अधिकारी एटापल्ली",
        "BDO Sironcha": "गट विकास अधिकारी सिरोंचा",
        "BDO Korchi": "गट विकास अधिकारी कोरची",
        "BDO Kurkheda": "गट विकास अधिकारी कुरखेडा",
        "BDO Wadsa": "गट विकास अधिकारी वडसा",
        "BDO Desaiganj": "गट विकास अधिकारी देसाईगंज",
        "BDO Bhamragad": "गट विकास अधिकारी भामरागड",
        "BDO Mulchera": "गट विकास अधिकारी मूलचेरा",
        // Panchayat Samiti
        "Panchayat Samiti Gadchiroli": "पंचायत समिती गडचिरोली",
        "Panchayat Samiti Aheri": "पंचायत समिती अहेरी",
        "Panchayat Samiti Armori": "पंचायत समिती आरमोरी",
        "Panchayat Samiti Chamorshi": "पंचायत समिती चामोर्शी",
        "Panchayat Samiti Dhanora": "पंचायत समिती धानोरा",
        "Panchayat Samiti Etapalli": "पंचायत समिती एटापल्ली",
        "Panchayat Samiti Sironcha": "पंचायत समिती सिरोंचा",
        "Panchayat Samiti Korchi": "पंचायत समिती कोरची",
        "Panchayat Samiti Kurkheda": "पंचायत समिती कुरखेडा",
        "Panchayat Samiti Wadsa": "पंचायत समिती वडसा",
        "Panchayat Samiti Desaiganj": "पंचायत समिती देसाईगंज",
        "Panchayat Samiti Bhamragad": "पंचायत समिती भामरागड",
        "Panchayat Samiti Mulchera": "पंचायत समिती मूलचेरा"
      },
      taluka: {
        "Gadchiroli": "गडचिरोली",
        "Aheri": "अहेरी",
        "Armori": "आरमोरी",
        "Chamorshi": "चामोर्शी",
        "Dhanora": "धानोरा",
        "Etapalli": "एटापल्ली",
        "Sironcha": "सिरोंचा",
        "Korchi": "कोरची",
        "Kurkheda": "कुरखेडा",
        "Wadsa": "वडसा",
        "Desaiganj": "देसाईगंज",
        "Bhamragad": "भामरागड",
        "Bhamaragad": "भामरागड",
        "Etapalli (S)": "एटापल्ली",
        "Mulchera": "मूलचेरा"
      },
      common: {
        na: 'नाही',
      },
      cards: {
        totalComplaints: 'एकूण तक्रारी',
        resolved: 'निराकरण झाले',
        pending: 'प्रलंबित',
        overdue21Days: '२१ दिवस उलटले',
      },
      "In Progress": "प्रक्रियेत",
      "New": "नवीन",
      "Pending": "प्रलंबित",
      "Resolved": "निराकरण झाले",
      "Reopen": "पुन्हा उघडा",
      "Rejected": "नाकारले",
      filter: {
        dateFrom: 'दिनांक पासून',
        dateTo: 'दिनांक पर्यंत',
      },
      modal: {
        citizenInfo: 'नागरिक माहिती',
        complaintInfo: 'तक्रार माहिती',
        complaintDesc: 'तक्रार वर्णन',
        officerNotes: 'अधिकाऱ्याचे नोट्स',
        citizenPhotos: 'नागरिक फोटो',
        officerPhotos: 'अधिकारी निराकरण फोटो',
        noCitizenPhotos: 'नागरिकाने फोटो अपलोड केलेले नाहीत',
      },
      reports: {
        exportExcel: 'एक्सेल मध्ये निर्यात करा',
        crmReport: 'दैनिक CRM अहवाल',
        agingReport: 'वयस्कर अहवाल',
        exportPdf: 'PDF मध्ये निर्यात करा',
        schedule: 'अहवाल नियोजन',
      },
      analytics: {
        deptPerformance: 'विभाग कार्यक्षमता आढावा',
        slaPerformance: 'SLA कार्यक्षमता विश्लेषण',
        monthlyTrends: 'मासिक ट्रेंड्स',
        priorityDist: 'प्राधान्य वितरण',
        slaTarget: 'SLA लक्ष्य',
        avgResolution: 'सरासरी निराकरण',
        slaBreaches: 'SLA उल्लंघन',
        compliance: 'अनुपालन दर',
        excellent: 'उत्तम',
        good: 'चांगले',
        needsImprovement: 'सुधारणा आवश्यक',
      },
      legend: {
        collectorPriority: 'संकुलकार्यालय प्राधान्य',
        citizenRaised: 'नागरिकाने नोंदवलेले',
      },
      section: {
        complaintsManagement: 'तक्रार व्यवस्थापन',
        raiseComplaint: 'तक्रार नोंदवा',
      },
      emptyState: {
        title: 'No Complaints Found',
        description:
          'There are currently no complaints matching your criteria.',
        suggestion: 'Try adjusting your filters or search terms.',
      },
      pagination: {
        first: 'पहिला',
        previous: 'मागील',
        next: 'पुढील',
        last: 'शेवटचा',
        pageOf: '{{total}} पैकी {{current}} पृष्ठ',
      },
      resolutionModal: {
        title: 'तक्रार निराकरण करा',
        idLabel: 'आयडी',
        closingComment: {
          label: 'समारोप टिप्पणी',
          required: 'समारोप टिप्पणी *',
          placeholder:
            'तक्रार कशी सोडवली, केलेल्या कृती आणि परिणाम वर्णन करा...',
          helpText: 'ही टिप्पणी नागरिकाला दिसेल',
        },
        photos: {
          label: 'निराकरण फोटो (पर्यायी)',
          uploadPrompt: 'निराकरण फोटो अपलोड करण्यासाठी क्लिक करा',
          fileTypes: 'PNG, JPG कमाल १०MB प्रति फाइल',
          selectedLabel: 'निवडलेली फाइल्स:',
        },
        warning: {
          title: 'महत्त्वाचे',
          message:
            'एकदा निराकरण केले की ही तक्रार पूर्ण झाली असे दाखवले जाईल. स्थिती ड्रॉपडाउन कायमस्वरूपी अक्षम होईल.',
        },
        buttons: {
          cancel: 'रद्द करा',
          resolve: 'तक्रार निराकरण करा',
          resolving: 'निराकरण होत आहे...',
        },
      },

      assign: {
        title: 'तक्रार वाटप करा',
        subtitle: 'या तक्रारीसाठी विभाग आणि अधिकारी निवडा',
        selectDepartment: 'विभाग निवडा',
        specialInstructions: 'विशेष सूचना (ऐच्छिक)',
        info: 'वाटप लगेच प्रक्रिया केले जाईल',
        button: 'आता वाटप करा',
        specialInstructionsPlaceholder:
          'विशेष सूचना, प्राधान्य नोट्स किंवा मुदत मर्यादा आवश्यकता जोडा...',
      },
      complaint: {
        dateSubmitted: 'तक्रार नोंदवलेली तारीख',
        currentStatus: 'सध्याची स्थिती',
      },
      "Complaint submitted successfully": "तक्रार यशस्वीरित्या सादर केली",
      "By": "द्वारे",
      "Citizen": "नागरिक",
      "Public": "सार्वजनिक",
      "Internal": "अंतर्गत",
      "Updated": "अद्यतनित",
    },
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: false,

    interpolation: {
      escapeValue: false,
    },

    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },
  });

export default i18n;
